export const normalize = (value) => value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/ /g, "");
export const looseMatch = (search, value) => {
    if (search.length === 0)
        return true;
    const valueN = normalize(value);
    const searchN = normalize(search);
    let pos = 0;
    for (let i = 0; i < valueN.length; i++) {
        if (pos < searchN.length && valueN[i] === searchN[pos]) {
            pos++;
            if (pos === searchN.length) {
                return true;
            }
        }
    }
    return false;
};
//# sourceMappingURL=search.js.map